import { Injectable } from '@angular/core';
import { Paginator } from '@app/classes';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { AuthService } from '@app/services';
import {
    ReportNameColumn,
    CreatedAtColumn,
    LastModifiedColumn,
    LastModifiedByColumn,
} from '@reporting/services/tables/custom-reports-table/columns';
import { CustomReportQuery } from '@app/models/reporting/custom-report-query.model';

const exportAsCsvOption: MenuColumnItem = {
    label: 'export-as-csv',
    event: 'exportAsCsv',
};

const exportAsXlxsOption: MenuColumnItem = {
    label: 'export-as-xlsx',
    event: 'exportAsXlxs',
};

const editOption: MenuColumnItem = {
    label: 'edit',
    event: 'edit',
};

const deleteOption: MenuColumnItem = {
    label: 'delete',
    event: 'delete',
};

@Injectable()
export class CustomReportsTable extends Table {
    links = true;
    showMenuColumnOptions = true;

    constructor(protected auth: AuthService) {
        super(auth);
        this.boot();
    }

    getLink(customReportQuery: CustomReportQuery): (string | number)[] {
        return ['/reporting', 'custom-reports', String(customReportQuery.id), 'report'];
    }

    getMenuColumnOptionsForRow(): MenuColumnItem[] {
        return [exportAsCsvOption, exportAsXlxsOption, editOption, deleteOption];
    }

    setColumns(): void {
        this.columns = [
            new ReportNameColumn(),
            new CreatedAtColumn(),
            new LastModifiedColumn(),
            new LastModifiedByColumn(),
        ];
    }

    setDataSource(): void {
        this.paginator = new Paginator(CustomReportQuery.with(['filters', 'lastUpdatedBy']));
    }
}
